<template>
  <div class="page_zeroRepairList">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="姓名" size="small">
              <el-input v-model="listQuery.EmployeeName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.ProjectId" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申报月" size="small">
              <el-date-picker v-model="listQuery.IncomeTaxMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="90px">
          <div>
            <el-form-item label="个税申报类型" size="small" label-width="115px">
              <el-select v-model="listQuery.IncomeTaxType" placeholder="" clearable filterable style="width:180px">
                <el-option value="正常工资薪金"></el-option>
                <el-option value="劳务报酬"></el-option>
                <el-option value="全年一次性奖金（一次扣税）"></el-option>
                <el-option value="全年多次性奖金（多次发放）"></el-option>
                <el-option value="解除劳动合同一次性补偿"></el-option>
                <el-option value="个税差额补发"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发放公司" size="small">
              <el-input v-model="listQuery.PayrollCompany" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="身份证" size="small">
              <el-input v-model="listQuery.CardId" size="small" clearable style="width:180px"></el-input>
            </el-form-item>

          </div>
          <!-- <div>
            <el-form-item label="服务部门" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="客服" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </div> -->
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/calcSalary' }">算薪</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/addCalcSalary',query: {
              Id: id,
              active: 2,
              ids:''
            } }">新增算薪</el-breadcrumb-item>
          <el-breadcrumb-item>零收入补录记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column prop="EmployeeName" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CardId" label="身份证" min-width="150" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IncomeTaxType" label="个税申报类型" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="PayrollCompany" label="发放公司" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IncomeTaxMonth" label="申报月" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ProjectName" label="项目" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CreateTime" label="操作时间" min-width="150" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              <div>{{row.CreateTime ? row.CreateTime.replace('T',' ') : ''}}</div>
              <div v-if="row.CancelTime">{{row.CancelTime ? row.CancelTime.replace('T',' ') : ''}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="IsDeleted" label="状态" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{row.IsDeleted ? '已作废' : '正常'}}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="80px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-popconfirm title="请确定是否作废？" @confirm="del(row)">
                  <el-button type="text" slot="reference">作废</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>

        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          EmployeeName: '',
          CardId: '',
          IncomeTaxType: '',
          IncomeTaxMonth: '',
          PayrollCompany: '',
          ProjectId: '',
          pageNum: 1,
          pageSize: 10,
        },
        showDropScreen: -1,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        id: '',
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      this.getProList();
      this.getList();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getList();
      },
      getList() {
        xz.ZeroRepairList(this.listQuery).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data;
            this.totalCount = res.totalcount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      del(row) {
        xz.CancellApplication(row.Id,this.roletype).then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.$message.success('作废成功！')
          } else {
            this.getList();
            this.$message.error(res.msg);
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }
</style>
<style>
  .page_zeroRepairList .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_zeroRepairList .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_zeroRepairList .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_zeroRepairList .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_zeroRepairList .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_zeroRepairList .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>